import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonModal,
    IonTitle,
    IonToolbar,
} from '@ionic/react';
import { Trans } from '@lingui/macro';
import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { qrCodeOutline } from 'ionicons/icons';
import { useCallback, useRef } from 'react';

import QRCodeScanner from '../../qrcodescanner/QRCodeScanner';
import DefaultInput from '../defaultinput/DefaultInput';

type IonInputProps = React.ComponentPropsWithoutRef<typeof IonInput>;
const QRCodeScannerInput: React.FC<
    IonInputProps & {
        inputClassName?: string;
    }
> = ({ className, inputClassName, disabled, name, ...rest }) => {
    const { setFieldValue } = useFormikContext();
    const modal = useRef<HTMLIonModalElement>(null);

    const onScanSuccess = useCallback(
        (qrCodeMessage: string) => {
            name && setFieldValue(name, qrCodeMessage, true);
            dismiss();
        },
        [name, setFieldValue]
    );

    const present = () => {
        modal.current?.present();
    };

    const dismiss = () => {
        modal.current?.dismiss();
    };

    return (
        <div className={classNames('qr-code-scanner-input', className)}>
            <DefaultInput
                className={inputClassName}
                disabled={disabled}
                name={name}
                {...rest}
            ></DefaultInput>
            <IonButton
                size="small"
                fill="clear"
                disabled={disabled}
                onClick={present}
            >
                <IonIcon slot="icon-only" icon={qrCodeOutline}></IonIcon>
            </IonButton>
            <IonModal ref={modal}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>
                            <Trans>Scan QR Code</Trans>
                        </IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={dismiss}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <QRCodeScanner
                        onScanSuccess={onScanSuccess}
                    ></QRCodeScanner>
                </IonContent>
            </IonModal>
        </div>
    );
};

export default QRCodeScannerInput;
